<template>
  <div class="canonical">
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <span class="pointer" @click="toPath('/achievements')">成果展示</span>
          <span v-if="formType">>></span>
          <span v-if="formType">成果形式</span>
          <span v-if="formType">>></span>
          <span v-if="formType">{{formType}}</span>
        </div>
      </div>
      <div class="title">{{formType}}</div>
      <div class="search-box">
        <div class="form-select">
          <label>成果形式：</label>
          <ul>
            <li v-for="t in formList" :class="t.text==formType?'selected':''" :key="t.text" @click="formType==t.text?formType=null:formType=t.text">{{t.text}}</li>
          </ul>
        </div>
      </div>
      <div class="search-box">
        <div class="type-select" v-if="typeList.length>0">
          <label>成果类型：</label>
          <ul>
            <li v-for="t in typeList" :class="t.name==type?'selected':''" :key="t.name" @click="type==t.name?type=null:type=t.name">{{t.name}}</li>
          </ul>
        </div>
        <div class="" style="flex: 1; display: flex">
          <input type="text" v-model="keyWords" placeholder="请输入相关字段，点击搜索">
          <span class="search-btn" @click="fetchFruitList">搜索</span>
        </div>
      </div>

      <div class="canonical-body">
          <ul v-if="result.length>0">
          <li v-for="fruit in result" :key="fruit.id">
            <div class="title-box">
              <router-link :to="'/fruitDetail?id=' + fruit.id"><span class="name pointer">{{ fruit.fruitName }}</span></router-link>
              <span class="code">{{ fruit.projectNumber }}</span>
            </div>
            <div class="content">
              <p>{{fruit.description}}</p>
            </div>
            <div class="date-box">
              <span>现阶段：{{fruit.nowStage}}</span>
            </div>
          </li>
        </ul>
        <div v-else class="no-data" style="text-align: center;padding: 40px;">
          暂无相关数据
        </div>
        <div class="pagination-box" v-if="page.total>0">
          <el-pagination
            background
            layout="prev, pager, next, total"
            :total="page.total"
            :page-size="page.pageSize"
            @current-change="pageChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formList: [
        {
          text: '标准样品'
        },
        {
          text: '规程/规范'
        },
        {
          text: '国际/国内比对'
        },
        {
          text: '国际标准'
        },
        {
          text: '国际互认的测量和校准能力'
        },
        {
          text: '国家标准物质'
        },
        {
          text: '国内标准'
        },
        {
          text: '国内标准修改单'
        },
        {
          text: '计量基标准'
        },
        {
          text: '检测设备/仪器'
        }
      ],
      formType: '',
      typeList: [],
      type: '',
      keyWords: '',
      page: {
        currPage: 1,
        pageSize: 10,
        total: 0
      },
      result: []
    }
  },
  mounted () {
    this.formType = this.$route.query.type;
    this.keyWords = this.$route.query.keyWords || '';
    this.fetchFruitType();
    this.fetchFruitList();
  },
  watch: {
    formType: function (val) {
      this.fetchFruitType()
    }
  },
  methods: {
    toPath (path) {
      this.$router.push(path)
    },
    fetchFruitType () {
      const _self = this;
      if (_self.formType) {
        _self.post('/dataapi/open/nqi/fruit/getFruitTypeByStyle?fruitStyle=' + _self.formType).then(res => {
          _self.typeList = [];
          for (let t of res.data) {
            _self.typeList.push({
              name: t,
              selected: false
            })
          }
        })
      }
    },
    pageChange (current) {
      this.page.currPage = current;
      this.fetchFruitList();
    },
    fetchFruitList () {
      // 请求成果列表
      const _self = this;
      let param = {};
      if (_self.formType) param.fruitStyle = _self.formType;
      if (_self.type) param.fruitType = _self.type;
      if (_self.keyWords) param.fruitName = _self.keyWords;
      param.pageNo = _self.page.currPage;
      param.pageSize = _self.page.pageSize;
      _self.fetch('/dataapi/open/nqi/fruit/likeList', param).then(res => {
        _self.result = res.result.records;
        _self.page.total = res.result.total
      })
    }
  }
}
</script>

<style lang="less">
.canonical {
  .pagination-box {
    margin-top: 60px;
    .el-pagination {
      button {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
      }
    }
    .el-pager {
      .number {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        &.active {
          background-color: rgba(46, 92, 154, 1)!important;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
}
.canonical {
  padding-bottom: 60px;
  .breadcrumb-box {
    margin-bottom: 24px;
    padding-top: 12px;
    .breadcrumb-body {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;
      span {
        margin-right: 7px;
      }
    }
  }
  .title {
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
  }
  .search-box {
    display: flex;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 24px;
    }
    .type-select, .form-select {
      display: flex;
      margin-top: 6px;
      label {
        font-size: 16px;
        line-height: 40px;
        width: 85px;
      }
      li {
        cursor: pointer;
        float: left;
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 0 10px;
        margin-right: 10px;
        line-height: 40px;
        border-radius: 4px;
        &.selected {
          background-color: #136BAE;
          color: #FFFFFF;
        }
      }
    }
    input {
      margin-right: 24px;
      margin-left: 12px;
      flex: 1;
      height: 52px;
      outline: none;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 26px;
      box-sizing: border-box;
    }
    .search-btn {
      width: 120px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      background-color: rgba(46, 92, 154, 1);
      cursor: pointer;
    }
  }
  .canonical-body {
    padding-bottom: 32px;
    ul {
      li {
        padding: 24px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .title-box {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          .name {
            font-size: 16px;
            font-weight: 500;
            color: rgba(46, 92, 154, 1);
            line-height: 22px;
          }
          .code {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 17px;
          }
        }
        .content {
          margin-bottom: 24px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          line-height: 28px;
        }
        .date-box {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.45);
          line-height: 17px;
        }
      }
    }
  }

  .pagination-box {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/canonical/index.vue